// 直播窗口
<template>
  <div class="livePlayerContainer" id="livePlayerContainer">
    <div class="lpMain" v-if="'id' in lID">
      <div class="lpMMain" id="lpMMain" :style="`height: ${clientWidth*9/16}px;`">
        <div class="lpMMMediaDiv" v-if="onPush&&lID.live">
          <video id="livePlayer" autoplay></video>
        </div>
        <div class="lpMMMediaDiv" v-else>
          <img :src="lID.publishCover">
        </div>
      </div>
    </div>
    <div class="lpMain" v-else>
      <div class="lpMMain" id="lpMMain">
        <div class="lpMMMediaDiv">
          <img src="../assets/liveIcon/noLiveCover.jpg">
        </div>
      </div>
      <div class="lpMHeader">
        <div class="lpMHTitle">
          <div class="lpMHTText">
            欢迎来到环保学园
          </div>
        </div>
      </div>
    </div>
    <div class="lpDLFooter">
      <div class="lpDLFDiv">
        <el-button class="lpFSDft" @click="ctrlLivePlayer('lpFS')"></el-button>
        <el-input class="lpDLFDInput" ref="dmInput" type="text" resize="none" v-model="dmSender.dmText" placeholder="发送弹幕" @keyup.enter.native="sendDm()"></el-input>
        <el-button class="lpDLFDBtn el-icon-s-promotion" @click="sendDm()"></el-button>
      </div>
    </div>
    <div class="lpDLMain" :style="`height: calc(100% - ${clientWidth*9/16}px - 110px);`">
      <div class="lpDLMBox" id="lpDLMBox">
        <div class="lpDLMBItem" v-for="(item, index) in dmBoxList" :key="index" @click="dmClick(item)">
          <span :style="{'color': item.color}">{{item.userName}}：</span><span>{{item.dmText}}</span>
        </div>
      </div>
    </div>
    <div class="lpMain" v-if="'id' in lID">
      <div class="lpMHeader">
        <div class="lpMHTitle">
          <div class="lpMHTText">
            {{ lID.publishTitle }}
          </div>
        </div>
      </div>
    </div>
    <div class="lpMain" v-else>
      <div class="lpMHeader">
        <div class="lpMHTitle">
          <div class="lpMHTText">
            欢迎来到环保学园
          </div>
        </div>
      </div>
    </div>
    <div class="lbLLHeader">
      <div class="lbLLHTitle">
        <div class="link-content-1">
          <span v-if="userName">
            <span class="login" @click="doLogin">{{userName}}</span>
          </span>
          <span v-else>
            <span class="login" @click="doLogin" style="padding:0 10px 0 0">登录/注册</span>
          </span>
          <span @click="$router.push('/h5download')" style="padding:0 0 0 20px">下载</span>
        </div>
      </div>
    </div>
    <accountCom :showLogin.sync="loginDialogShow" @dispatchUserName="receiveName"></accountCom>
  </div>
</template>

<script>
import api from '../../api/index'
import flvjs from 'flv.js'
import accountCom from '@/components/account/index'
export default {
  props: ['liveItemData', 'userInfoData', 'userLiveData'],
  data () {
    return {
      clientWidth: 0,
      liveDatas: {},
      lID: {},
      uID: {},
      uLD: {},
      lPlayer: null,
      lpOpt: {
        muted: false,
        lpFS: false,
        webFS: false
      },
      onPush: false,
      dmBoxList: [],
      dmSender: {
        // id: 0,
        userName: '',
        dmText: '',
        dmTime: 0,
        dmLv: '',
        roomId: 0
      },
      roomId: 0,
      oprdDm: {},
      lastDmId: '',
      dmMaxLen: 100,
      moreDm: false,
      unixTime: 0,
      playTime: 0,
      onPushRTI: 10000,
      dmRTI: 2000,
      dmColor: {
        aSUser: '#000000',
        aSUserDm: '#ffffff',
        bSUser: '#228B22',
        cSUser: '#002FA7',
        dSUser: '#8A2BE2',
        eSUser: '#D2691E',
        liveAdmin: '#FF0000'
      },
      ifShowDmOprBox: false,
      onPushCcltor: null,
      dmCcltor: null,
      isMuted: false,
      isAdmin: false,
      dmOprType: 'default',
      showDmOprF: false,
      loginDialogShow: false,
      userName: sessionStorage.getItem('qs_user_name')
    }
  },
  mounted () {
    this.clientWidth = document.body.clientWidth
    if (this.$route.query.liveItemData) {
      this.lID = JSON.parse(this.$route.query.liveItemData)
      this.uID = JSON.parse(this.$route.query.userInfoData)
      this.uLD = JSON.parse(this.$route.query.userLiveData)
      console.log(this.$route.query, this.lID, this.uID, this.uLD)
      this.initData()
      // this.initLivePlayer()
      // this.getOnPush()
      this.clearDmBoxList()
    }
  },
  methods: {
    initData () {
      console.log('liveDatas', this.lID)
      if ('id' in this.lID) {
        this.roomId = this.lID.id
        this.onPush = this.lID.onPush
        this.getOnPush()
        this.onPushCcltor = setInterval(this.getOnPush, this.onPushRTI)
        this.isMuted = this.uLD.muted
        this.isAdmin = this.uLD.liveAdmin
        if (!this.isMuted) {
          this.dmSender.userName = this.uID.name
          if (this.isAdmin) {
            this.dmSender.dmLv = '直播管理员'
          } else {
            this.dmSender.dmLv = this.uID.grade
          }
          this.dmSender.roomId = this.roomId
        }
      }
    },
    initLivePlayer () {
      setTimeout(() => {
        if (flvjs.isSupported()) {
          if (this.lID.live) {
            this.lPlayer = null
            var videoElement = document.getElementById('livePlayer')
            this.lPlayer = flvjs.createPlayer({
              type: 'flv', // 媒体类型 flv 或 mp4
              isLive: true, // 是否为直播流
              hasAudio: !this.lpOpt.muted, // 是否开启声音
              url: this.lID.live // 视频流地址
            })
            this.lPlayer.attachMediaElement(videoElement)
            this.lPlayer.load()
            // this.player.play()
          } else {
            console.log('未查询到拉流地址')
          }
        } else {
          console.log('flvjs不支持')
        }
      }, 1000)
    },
    ctrlLivePlayer (type) {
      switch (type) {
        case 'lpFS':
          if (this.lPlayer) {
            var lpContainer = document.getElementById('lpMMain')
            lpContainer.webkitRequestFullScreen()
          }
          break
      }
    },
    getOnPush () {
      api.spLiveEnquiry({
        phone: this.lID.phone,
        isOnPush: 1
      }).then(resOnPush => {
        if (resOnPush.code === 200) {
          this.onPush = resOnPush.data.OnPush
          if (this.onPush && !this.dmCcltor) {
            this.initDmList()
            this.initLivePlayer()
          } else if (this.dmCcltor && !this.onPush) {
            clearInterval(this.dmCcltor)
            this.lPlayer = null
            this.dmCcltor = null
          }
        }
      })
    },
    initDmList () {
      this.clearDmBoxList()
      this.dmCcltor = setInterval(this.getDmList, this.dmRTI)
    },
    getDmList () {
      var dmBox = document.getElementById('lpDLMBox')
      var ifSTB = dmBox.scrollHeight <= dmBox.scrollTop + dmBox.clientHeight
      this.unixTime = new Date().getTime()
      var lastId = this.dmBoxList[this.dmBoxList.length - 1].id
      var dmTime = this.unixTime - this.dmRTI * 2
      var enquiryPusher = {
        roomId: this.roomId
      }
      if (lastId === 2) {
        enquiryPusher.dmTime = dmTime
      } else {
        enquiryPusher.lastId = lastId
      }
      api.spLiveDmEnquiry(enquiryPusher).then(resDmList => {
        if (resDmList.code === 200 && resDmList.data[0]) {
          console.log('resDmList', resDmList)
          resDmList.data.forEach(resDmItem => {
            console.log('resDmItem', resDmItem.id + '>' + this.dmBoxList[this.dmBoxList.length - 1].id + '?' + lastId)
            if (resDmItem.id > this.dmBoxList[this.dmBoxList.length - 1].id) {
              var dmPusher = {}
              dmPusher.id = resDmItem.id
              dmPusher.userName = resDmItem.userName
              dmPusher.userId = resDmItem.userId
              dmPusher.dmText = resDmItem.dmText
              dmPusher.dmLv = resDmItem.dmLv
              switch (dmPusher.dmLv) {
                case '一星智友':
                  dmPusher.color = this.dmColor.aSUser
                  break
                case '二星智友':
                  dmPusher.color = this.dmColor.bSUser
                  break
                case '三星智友':
                  dmPusher.color = this.dmColor.cSUser
                  break
                case '四星智友':
                  dmPusher.color = this.dmColor.dSUser
                  break
                case '五星智友':
                  dmPusher.color = this.dmColor.eSUser
                  break
                case '直播管理员':
                  dmPusher.color = this.dmColor.liveAdmin
                  break
                default:
                  dmPusher.color = this.dmColor.aSUser
              }
              this.dmBoxList.push(JSON.parse(JSON.stringify(dmPusher)))
              this.$nextTick(() => {
                this.moreDm = true
                if (ifSTB) {
                  this.dmScrollToBottom()
                  if (this.dmBoxList.length > this.dmMaxLen) {
                    var dmLen = this.dmBoxList.length
                    this.dmBoxList.splice(0, dmLen - this.dmMaxLen)
                  }
                }
              })
            }
          })
        }
      })
    },
    sendDm () {
      api.spLiveEnquiry({
        phone: this.uID.phone
      }).then(resIsM => {
        console.log('resIsM', resIsM)
        if (resIsM.code === 200) {
          this.isMuted = resIsM.data.list[0].muted
          if (!this.isMuted) {
            if (this.onPush) {
              if (this.dmSender.dmText) {
                this.dmSender.dmTime = new Date().getTime()
                api.spLiveDmAdd(this.dmSender).then(resDmAdd => {
                  console.log(resDmAdd)
                  if (resDmAdd.code === 200) {
                    this.dmSender.dmText = ''
                    // var sucMsg = confirm('发送弹幕成功')
                    // if (sucMsg) {}
                  }
                })
              } else {
                this.$toast.text('未输入内容')
              }
            } else {
              this.$toast.text('讲座准备中')
            }
          } else {
            this.$toast.text('您已被禁言')
          }
        } else {
          this.$toast.text('发送失败')
        }
      })
    },
    dmScrollToBottom () {
      var dmBox = document.getElementById('lpDLMBox')
      console.log(dmBox.scrollTop + '+' + dmBox.scrollHeight + '>' + dmBox.clientHeight + '?')
      dmBox.scrollTop = dmBox.scrollHeight - dmBox.clientHeight + 2
      this.moreDm = false
    },
    clearDmBoxList () {
      api.spLiveDmEnquiry({
        id: 1
      }).then(resDm1 => {
        console.log('resDm1', resDm1)
        if (resDm1.code === 200) {
          api.spLiveDmEnquiry({
            id: 2
          }).then(resDm2 => {
            var item1 = resDm1.data
            item1.color = '#FF0000'
            var item2 = resDm2.data
            item2.color = '#FF0000'
            this.dmBoxList = [item1, item2]
          })
        } else {
          this.userName = ''
        }
      })
    },
    dmClick (item) {
      if (item.id !== 1 && item.id !== 2) {
        console.log(item)
        this.replyDm(item)
      }
    },
    doReserveLive () {
      console.log('doReserve')
      api.spLiveReservationUpdate().then(res => {
        this.$toast.text(res.message)
      })
    },
    doLogin () {
      this.loginDialogShow = true
    },
    receiveName (val) {
      this.userName = val
      this.$emit('dispatchUserName', val)
      this.$router.push('/h5Live-list')
    },
    replyDm (oprdDm) {
      this.dmOprType = 'replying'
      this.showDmOprF = false
      this.dmSender.dmText = '回复' + oprdDm.userName + '：'
      this.$refs.dmInput.focus()
    }
  },
  beforeDestroy () {
    console.log('destroy')
    this.lPlayer = null
    clearInterval(this.onPushCcltor)
    clearInterval(this.dmCcltor)
  },
  components: {
    accountCom
  }
}
</script>

<style lang="scss">
.livePlayerContainer{
  width: 100%;
  height: calc(100% - 20px);
  background-color: #f9f9f9;
  font-family: 'Times New Roman', 'SimHei', Georgia, Times, serif;
  .lbLLHeader{
    width: 100%;
    height: 40px!important;
    // padding: 10px;
    .lbLLHTitle{
      width: calc(100% - 10px);
      height: 30px!important;
      padding: 4px;
      text-align: center;
      font-size: 20px;
      display: flex;
      border: #ddd solid 1px;
      background-color: #eee;
      .link-content-1{
        width: 100%;
        height: 30px;
        text-align: center;
        line-height: 30px;
        margin: 0 4px;
      }
    }
  }
  .lpMain{
    width: 100%;
    // border: #ddd solid 1px;
    background-color: #eee;
    .lpMHeader{
      width: calc(100% - 10px);
      height: 48px!important;
      padding: 4px!important;
      border: #ddd solid 1px;
      text-align: center;
      font-weight: bold;
      .lpMHTitle{
        .lpMHTText{
          width: 100%;
          // width: calc(100% - 8px);
          // margin: 0 4px;
          line-height: 24px;
          font-size: 18px;
        }
      }
    }
    .lpMMain{
      width: 100%;
      // height: calc(100% - 68px - 68px)!important;
      // padding: 0 4px!important;
      .lpMMMediaDiv{
        width: 100%;
        height: 100%;
        background-color: #000;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          object-fit: contain!important;
          max-width: 100%;
          max-height: 100%;
        }
        video{
          object-fit: contain!important;
          max-width: 100%;
          max-height: 100%;
        }
        video::-webkit-media-controls-enclosure{
          display: none;
        }
      }
    }
  }
  .lpDLMain{
    width: 100%;
    background-color: #eee;
    display: flex;
    .lpDLMBox{
      width: calc(100% - 4px);
      padding: 2px 2px 0;
      background-color: #f9f9f9;
      overflow-y: auto;
      .lpDLMBItem{
        width: calc(100% - 10px);
        margin: 0 0 2px;
        padding: 4px;
        border: #ddd solid 1px;
        border-radius: 4px;
        background-color: #eee;
      }
      .lpDLMBItem:hover{
        background-color: #ccc;
      }
    }
    .lpDLMBox::-webkit-scrollbar{
      display: none;
    }
  }
  .lpDLFooter{
    width: 100%;
    height: 32px!important;
    // padding: 4px!important;
    .lpDLFDiv{
      width: 100%;
      height: 100%;
      display: flex;
      .el-input{
        width: calc(100% - 64px);
        height: 100%;
      }
      .el-input__inner{
        height: 100%;
        border-radius: 0!important;
      }
      .el-button{
        width: 32px!important;
        height: 100%;
        padding: 6px;
        border-radius: 0!important;
        background-color: #f9f9f9;
        font-size: 16px;
        line-height: 20px;
      }
      .lpFSDft{
        background: no-repeat center/24px;
        background-color: #f9f9f9;
        background-image: url('../assets/mapicons/fullScreenEnter.png');
      }
    }
  }
}
</style>
